import { bodyShadowY } from './BodyShadowStore';

export const updateBodyShadowY = (value) => bodyShadowY.update(oldValue => value);
